// extracted by mini-css-extract-plugin
export default {"btn":"IconButton_btn__dCbsj","primary":"IconButton_primary__VdnrS"};